import { Instrument } from '../../types'

export const INSTRUMENT_CATEGORIES = [
  { name: 'All', instrument: undefined },
  { name: 'Stocks', instrument: Instrument.stock },
  { name: 'Futures', instrument: Instrument.futures },
  { name: 'Forex', instrument: Instrument.forex },
  { name: 'Crypto', instrument: Instrument.crypto },
]
